import {autoinject, transient} from 'aurelia-dependency-injection';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import {Dashboard, SingleDashboardAssignment, GetDashboardAssignmentsRequest} from '../../../../models/dashboard/dashboard.models';
import {DashboardClientService} from '../../../../services/dashboard/dashboard-client.service';
import { NotificationClientService, NotificationType } from '../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';

@transient()
@autoinject()
export class ShareDashboardDialog {
    public dashboard: Dashboard;
    public branchId: number;
    public departmentId: number;
    public roleId: number;
    public userId: number;  
    public readOnly: boolean = false;  
    public branchIdsToFilter: number[] = [];
    public departmentIdsToFilter: number[] = [];
    public roleIdsToFilter: number[] = [];
    public userIdsToFilter: number[] = [];
    
    constructor(private dialogClient: DialogClientService, private dashboardClientService: DashboardClientService, private notificationService: NotificationClientService,
        private i18N: I18N){}   
  
    cancel(){
        this.dialogClient.hide();
    }

    share(){
        return new Promise<void>((resolve,reject) => {
            if(this.branchId == null){
                this.notificationService.show(this.i18N.tr('empty-fields'), this.i18N.tr('empty-fields-description-share-dashboard'), NotificationType.Warning);
                reject();
                return;
            }
    
            if(this.userId == null) this.userId = 0;
            if(this.roleId == null) this.roleId = 0;
            if(this.departmentId == null) this.departmentId = 0;
    
            this.dashboardClientService.shareDashboard(<SingleDashboardAssignment>{
                dashboardId: this.dashboard.dashboardId, 
                userId: this.userId, 
                roleId: this.roleId, 
                departmentId: this.departmentId, 
                branchId: this.branchId
            }, this.readOnly)
            .then(response => {           
                if(response){
                    this.notificationService.show(this.i18N.tr('successful-sharing'),this.i18N.tr('successful-sharing-description'), NotificationType.Success);
                }
                else{
                    this.notificationService.show(this.i18N.tr('failed-sharing'),this.i18N.tr('failed-sharing-description') , NotificationType.Error);
                }

                this.dialogClient.hide();           
                resolve(); 
            })
            .catch(() => {
                this.notificationService.show(this.i18N.tr('error-text'), this.i18N.tr('error-sharing-description') , NotificationType.Error);
            });       
        });      
    }
    
    activate(model : any) {
        if (model && model.dashboard){
            this.dashboard = model.dashboard;            
        }        

        this.dashboardClientService.getDashboardAssignments(<GetDashboardAssignmentsRequest>{dashboardId: this.dashboard.dashboardId}).then(x => {
            x.dashboardAssignment.branches.forEach(y => this.branchIdsToFilter.push(y.id));
            x.dashboardAssignment.departments.forEach(y => this.departmentIdsToFilter.push(y.id));
            x.dashboardAssignment.roles.forEach(y => this.roleIdsToFilter.push(y.id));
            x.dashboardAssignment.users.forEach(y => this.userIdsToFilter.push(y.id));
        });
    }
}
